import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TestTube, Heart, Stethoscope, Baby, Building2, Home, Microscope } from 'lucide-react';
import ScrollReveal from '@/components/animations/ScrollReveal';
import { services } from '@/data/services';
import { useLanguage } from '@/hooks/useLanguage';
import { useContent } from '@/hooks/useContent';

const Services = () => {
  const { t } = useContent();
  const { language } = useLanguage();

  useEffect(() => {
    document.title = 'Services - ElhamyLabs';
  }, []);

  const iconMap: Record<string, any> = {
    TestTube,
    Heart,
    Stethoscope,
    Baby,
    Building2,
    Home,
    Microscope,
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-brand-purple-dark via-brand-purple-base to-brand-purple-light dark:from-dark-primary dark:via-dark-secondary">
        <div className="container mx-auto px-4 text-center">
          <ScrollReveal>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 text-white">
              {t('common.services')}
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              {t('services.subtitle')}
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-light-primary dark:bg-dark-primary">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => {
              const Icon = iconMap[service.icon] || TestTube;
              return (
                <ScrollReveal key={service.id} delay={index * 0.1}>
                  <Link
                    to={service.route}
                    className="group block p-8 bg-light-secondary dark:bg-dark-secondary rounded-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-pointer border-2 border-transparent hover:border-brand-purple-base/20 dark:hover:border-brand-orange-base/20"
                  >
                    <div className="w-20 h-20 mb-6 rounded-full bg-brand-purple-base/10 dark:bg-brand-orange-base/10 flex items-center justify-center group-hover:bg-brand-purple-base/20 dark:group-hover:bg-brand-orange-base/20 group-hover:scale-110 transition-all duration-300">
                      <Icon size={40} className="text-brand-purple-base dark:text-brand-orange-base group-hover:scale-110 transition-transform duration-300" />
                    </div>
                    <h3 className="text-2xl font-bold mb-3 text-light-text dark:text-dark-text group-hover:text-brand-purple-base dark:group-hover:text-brand-orange-base transition-colors duration-300">
                      {service.name[language]}
                    </h3>
                    <p className="text-light-text-secondary dark:text-dark-text-secondary">
                      {service.description[language]}
                    </p>
                  </Link>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;

